// Firebase Configuration
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBTrdVY62LNeFrThCHGuYfzZvBay7n-hXk",
  authDomain: "etech-ab084.firebaseapp.com",
  projectId: "etech-ab084",
  storageBucket: "etech-ab084.firebasestorage.app",
  messagingSenderId: "737478632453",
  appId: "1:737478632453:web:b53a9dd0cdb2ec9848a86c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.log("FCM not supported in this environment:", error);
}

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    // Check if notifications are supported
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return null;
    }

    // Check if service worker is supported
    if (!("serviceWorker" in navigator)) {
      console.log("Service Worker not supported");
      return null;
    }

    // Request permission
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Notification permission granted");

      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: "BMkUjDSxqpNXAagIY3zjtEKaP8XSikcHzJpwfdxonBW0pPieLCjHb6jwzPSMya4jXlLOTBLTdJOFgzveD5xe8Fw"
      });

      if (token) {
        console.log("FCM Token:", token);
        return token;
      } else {
        console.log("No registration token available");
        return null;
      }
    } else {
      console.log("Notification permission denied");
      return null;
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
    return null;
  }
};

// Listen for foreground messages - returns unsubscribe function
export const onMessageListener = (callback) => {
  if (messaging && callback) {
    return onMessage(messaging, (payload) => {
      console.log("Message received in foreground:", payload);
      callback(payload);
    });
  }
  return () => {};
};

export { app, messaging };
